module.exports = __webpack_public_path__ + "static/media/vector1.4a59870c.svg";